import { render, staticRenderFns } from "./type-card.vue?vue&type=template&id=4ae8f319&"
import script from "./type-card.vue?vue&type=script&lang=ts&"
export * from "./type-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports